
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 64 64","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M51.8,34.7c-0.2-1.5-1.7-4.1-2.1-4.8c-0.8-1.3-1.2-1-2.7-1.2c0,0-3.8-7.3-4.7-7.4c-8.4-0.5-17.2-0.5-21.9,0.3\n\t\tc-1.8,0.3-3.8,7.1-3.8,7.1c-1.4,0.6-3.3,5.1-3.4,6c-0.1,1.1,0.2,3.6,0.2,3.6h0.5c0,3.4,2.8,6.2,6.2,6.2c2.1,0,4-1.1,5.1-2.8h14.5\n\t\tc1.1,1.7,3,2.8,5.1,2.8c3.4,0,6.2-2.8,6.2-6.2h0.5C51.5,38.4,52,36.2,51.8,34.7z M20,41.5c-1.7,0-3.1-1.4-3.1-3.1\n\t\tc0-1.7,1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1C23.1,40.1,21.7,41.5,20,41.5z M19.8,28.7l0.7-1.5l2.8-0.1l0.2-0.5l-2.8,0.1l0.4-0.7\n\t\tl2.7-0.1l0.2-0.5l-2.6,0.1l0.4-0.6l2.5-0.1l0.2-0.5L22,24.3c0,0,0.7-1.2,1-1.3c2-0.3,15.2-0.5,16.8,0c1.7,0.6,3.9,5.6,3.9,5.6H19.8\n\t\tz M44.8,41.5c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1C47.9,40.1,46.5,41.5,44.8,41.5z"}})])
          )
        }
      }
    